/**
 * ConfirmModal styled components
 */

import styled from 'styled-components'
import Modal from 'antd/lib/modal'

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 0;
    border: var(--border-regular) solid var(--neutral-border-light);
    box-shadow: 0 16px 16px rgba(10, 10, 9, 0.08);
  }
  .ant-modal-body {
    padding: 0;
  }
  @media (max-width: 767px) {
    margin-inline: 20px;
    .ant-modal-content {
      box-shadow: 0 12px 12px rgba(10, 10, 9, 0.1);
    }
  }
`

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-24);
  padding: var(--spacing-32);
  @media (max-width: 767px) {
    gap: var(--spacing-16);
    padding: var(--spacing-24) 20px;
  }
  .message {
    color: var(--neutral-body);
    font: 400 14px/22px var(--font-inter);
  }
  .titleBlock {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-4);
    .title {
      margin: 0;
      color: var(--neutral-darkest);
      font: 600 32px/38px var(--font-barlow-semi-condensed);
      text-transform: capitalize;
    }
  }
`

export const HeaderRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  min-height: 24px;
  @media (max-width: 767px) {
    min-height: 18px;
  }
  .red-line {
    width: 48px;
    height: 4px;
    background: var(--accent-red);
  }
`

export const CloseIcon = styled.img`
  max-width: 16px;
  cursor: pointer;
  @media (max-width: 767px) {
    max-width: 14px;
  }
`

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  gap: var(--spacing-12);
  .btns {
    flex: 1;
  }
  @media (max-width: 767px) {
    flex-direction: column-reverse;
    gap: var(--spacing-8);
    .btns {
      flex: none;
    }
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ConfirmModal/styledComponents.tsx